import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowDownCircleIcon',
  props: {
    color: null
  },
  setup(__props: any) {

const props = __props as { color?: string };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.99992 1.33337C11.6759 1.33337 14.6666 4.32404 14.6666 8.00004C14.6666 11.676 11.6759 14.6667 7.99992 14.6667C4.32392 14.6667 1.33325 11.676 1.33325 8.00004C1.33325 4.32404 4.32392 1.33337 7.99992 1.33337ZM7.99992 2.33337C4.87525 2.33337 2.33325 4.87537 2.33325 8.00004C2.33325 11.1247 4.87525 13.6667 7.99992 13.6667C11.1246 13.6667 13.6666 11.1247 13.6666 8.00004C13.6666 4.87537 11.1246 2.33337 7.99992 2.33337ZM10.6673 6.68397C10.8626 6.87864 10.8633 7.19531 10.6686 7.39131L8.35392 9.71531C8.27925 9.79104 8.1824 9.83989 8.07872 9.85641L7.99992 9.86264C7.86725 9.86264 7.73925 9.80997 7.64592 9.71531L5.33192 7.39131C5.13659 7.19531 5.13792 6.87864 5.33325 6.68397C5.52925 6.48931 5.84592 6.48931 6.04059 6.68531L7.99992 8.65464L9.95992 6.68531C10.1546 6.48931 10.4713 6.48931 10.6673 6.68397Z",
      fill: __props.color || '#5528B5'
    }, null, 8, _hoisted_2)
  ]))
}
}

})